import { IPagination } from "./user";

export enum ReportCustomFieldType {
  NUMBER = "number",
  STRING = "string",
}

export type IReportDataFieldValue = number | string;

export interface IReportCustomFieledConfig {
  key: string;
  isSpecialField: boolean;
  category?: string;
  type?: ReportCustomFieldType;
  defaultValue?: IReportDataFieldValue;
  description?: string;
  displayName?: string;
  _id?: string;
}

export interface IGetReport {
  _id: string;
  name: string;
  createdByType: string;
  createdAt: string;
  updatedAt: string;
  noOfMedias: number;
  __v: 0;
  brief?: {
    _id: string;
    name: string;
  };
  type: "Custom" | "Brief";
}

export interface MediaData {
  comments: number;
  likes: number;
  views: number;
  shares: number;
  engRate: number;
  createdAt: string;
}

export interface CommentData {
  _id: string;
  negativeComment: string[];
  positiveComment: string[];
  noOfCommentsAnalysed: number;
  noOfIntentToBuy: number;
  noOfNegativeComment: number;
  noOfNeutralComment: number;
  noOfPostiveComment: number;
  noOfRevelantComment: number;
}
export interface AggregateCommentData {
  analysedComments: number;
  relevantComments: number;
  relevantCommentPercentage: number;
  postiveComments: number;
  postiveCommentsPercentage: number;
  intentToBuyProduct: number;
  intentToBuyProductPercentage: number;
}

export interface AggregateSocialData {
  totalLikes: number;
  avgLikes: number;
  totalComments: number;
  avgComments: number;
  totalViews: number;
  avgViews: number;
  totalShares: number;
  avgShares: number;
  totalEng: number;
  avgEng: number;
  totalImpressions: number;
  avgImpressions: number;
  engRate: number;
}

export interface ReportMedia {
  _id: string;
  reportId: string;
  link: string;
  platform: string;
  username: string;
  mediaUrl: string;
  mediaId: string;
  createdBy: string;
  createdByModelName: string;
  createdByType: string;
  mediaDataHistory: MediaData[];
  createdAt: string;
  updatedAt: string;
  __v: number;
  mediaData: MediaData;
  mediaDataLastUpdatedAt?: string;
  commentDataLastUpdatedAt?: string;
  commentData?: CommentData;
  reportMediaId: string;
  mediaType: string;
  postedOn: string;
  isNonTrackable?: boolean;
  nonTrackableReason?: string;

  cost?: number;

  /** Values for report-level custom fields (keys match `IFieldConfig.key`). */
  dynamicFields?: {
    [key: string]: string | number;
  };

  mediaDataStatus: MediaDataStatus;
  commentDataStatus: MediaDataStatus;
  socialMedia: {
    platform: string;
    username: string;
    link: string;
    profilePicUrl: string;
    searchV1?: { fullName: string };
  };
}

export enum MediaDataStatus {
  Pending = "Pending",
  Success = "Success",
  Failed = "Failed",
}

export type TimeseriesDataV1 = {
  [key: string]: {
    likes: number;
    comments: number;
    shares: number;
    views: number;
    engRate: number;
  };
};

export type TimeseriesDataV2 = {
  [key: string]: {
    deltaLikes: number;
    deltaComments: number;
    deltaShares: number;
    deltaViews: number;
    date: string;
    noOfMediasWithData: number;
  };
};

interface IReportDetailBase {
  data: ReportMedia[];
  pagination: IPagination;
  aggregateData: {
    social: AggregateSocialData;
    commments: AggregateCommentData;
    platforms: {
      platform: string;
      count: number;
    }[];
  };
}

interface IReportMetaBase {
  _id: string;
  name: string;
  type: ReportType;
  customFieldsV2?: IReportCustomFieledConfig[];
  visibileCustomFieldsV2: IReportCustomFieledConfig[];
}

export type IReportConfigV2 = {
  nextUpdateAt: string;
  updateTillDate: string;
  schedulerLeaseUntil: string;
  schedulerLeaseVersion: number;
  updateForIntervalHourFrequency: number;
  updateTillDays: number;
  updationTimeseries: {
    _id: string;
    currentUpdateForDateTime: string;
    actualUpdateForDateTime: string;
    createdAt: string;
    delayInSeconds: number;
    id: string;
  }[];
};

export type IReportDetail =
  | (IReportDetailBase & {
      timeseriesData: TimeseriesDataV1;
      report: IReportMetaBase & { version: "v1" };
    })
  | (IReportDetailBase & {
      timeseriesData: TimeseriesDataV2;
      report: IReportMetaBase & {
        version: "v2";
        configV2: IReportConfigV2;
      };
    });

export enum ReportType {
  Custom = "Custom",
  Brief = "Brief",
}

export interface IGetReports {
  data: IGetReport[];
  pagination: IPagination;
}

export interface IValidateReportCsvResponse {
  link: string;
  status: "failed" | "success";
  errors?: string[];
  rowNumber: number;
}
